// extracted by mini-css-extract-plugin
export default {"socialIcon":"socialsvg_socialIcon__tZh7w"};